import "./src/styles/global.css";

// Carry ad UTM params (e.g. LinkedIn) from the landing URL through to outbound
// App Store / help center links, so installs can be attributed to the campaign.
// Mirrors the same script in the Help Scout Docs site header (support.orderautomator.com).
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"];
const PASS_HOSTS = ["apps.shopify.com", "support.orderautomator.com"];
const STORAGE_KEY = "oa_utm";

const readStoredUtms = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
};

const captureUtms = () => {
  const params = new URLSearchParams(window.location.search);
  const fresh = {};
  UTM_KEYS.forEach((k) => {
    if (params.get(k)) fresh[k] = params.get(k);
  });
  if (Object.keys(fresh).length) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
    } catch (e) {}
  }
};

const tagLink = (a) => {
  const utms = readStoredUtms();
  if (!Object.keys(utms).length) return;
  try {
    const url = new URL(a.href);
    if (!PASS_HOSTS.includes(url.hostname)) return;
    UTM_KEYS.forEach((k) => {
      if (utms[k] && !url.searchParams.has(k)) url.searchParams.set(k, utms[k]);
    });
    a.href = url.toString();
  } catch (e) {}
};

export const onClientEntry = () => {
  captureUtms();
  // Capture phase so the href is updated before the browser follows the link.
  const onLinkEvent = (e) => {
    const a = e.target.closest && e.target.closest("a[href]");
    if (a) tagLink(a);
  };
  ["click", "auxclick", "contextmenu"].forEach((type) => document.addEventListener(type, onLinkEvent, true));
};
